import { useApiQuery } from './useApiQuery';
import { sftpUsersApi } from '@/api/sftpUsers';
import type { SftpUser, SftpUserFilters } from '@/api/sftpUsers';

interface UseSftpUsersOptions extends SftpUserFilters {
  enabled?: boolean;
}

export const useSftpUsers = (options: UseSftpUsersOptions = {}) => {
  const { clientId, userId, isActive, q, enabled = true } = options;

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<SftpUser[]>(
    {
      queryFn: () => sftpUsersApi.list({ clientId, userId, isActive, q }),
      enabled,
    },
    [clientId, userId, isActive, q],
  );

  return {
    sftpUsers: data ?? [],
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
